export const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?!.*[\s])[aA-zZ\d.#?!@$%^&*-]{8,255}$/;

export const URL_REGEX = new RegExp(
  "^(?:http(s)?:\\/\\/)?[\\w.-]+(?:\\.[\\w.-]+)+[\\w\\-._~:\\/?#[\\]@!$&'()*+,;=.]+$",
  'i'
);
